import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';

export const callUrlStorePostApi = async (payload) => {
    const { data = [] } = await axiosInstanceClient.post(API.manageUrl, payload);
    return data;
};

export const callUrlStoreGetApi = async () => {
    const { data = [] } = await axiosInstanceClient.get(API.dummyapi);
    return data;
};

